module.exports = __webpack_public_path__ + "static/media/bharat_bill_pay.1a18c54b.png";